"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.codingbarApi = exports.CodingbarApi = void 0;
var AuthServiceImpl_1 = require("./src/v1/impl/AuthServiceImpl");
var CourseServiceImpl_1 = require("./src/v1/impl/CourseServiceImpl");
var ExerciseServiceImpl_1 = require("./src/v1/impl/ExerciseServiceImpl");
var UserServiceImpl_1 = require("./src/v1/impl/UserServiceImpl");
var Future_1 = require("./src/v1/utils/Future");
var FirebaseApp_1 = require("./src/v1/impl/firebase/FirebaseApp");
var NotificationServiceImpl_1 = require("./src/v1/impl/NotificationServiceImpl");
var FeedbackServiceImpl_1 = require("./src/v1/impl/FeedbackServiceImpl");
var FirebaseUtils_1 = require("./src/v1/impl/firebase/FirebaseUtils");
var Utils_1 = require("./src/v1/utils/Utils");
var QuestionServiceImpl_1 = require("./src/v1/impl/QuestionServiceImpl");
var UserCache_1 = require("./src/v1/impl/UserCache");
var HistoryServiceImpl_1 = require("./src/v1/impl/HistoryServiceImpl");
var DashboardServiceImpl_1 = require("./src/v1/impl/DashboardServiceImpl");
var FormServiceImpl_1 = require("./src/v1/impl/FormServiceImpl");
var RegistrationServiceImpl_1 = require("./src/v1/impl/RegistrationServiceImpl");
var BulletinServiceImpl_1 = require("./src/v1/impl/BulletinServiceImpl");
var DocumentServiceImpl_1 = require("./src/v1/impl/DocumentServiceImpl");
var CoreServiceHelper_1 = require("./src/v1/impl/provider/airabbi/CoreServiceHelper");
var Settings_1 = require("./src/v1/impl/Settings");
var NoteServiceImpl_1 = require("./src/v1/impl/NoteServiceImpl");
var CodingbarApi = (function () {
    function CodingbarApi() {
        var _this = this;
        this.logger = console;
        this.isInit = false;
        this.getFormService = function () {
            _this.onActive();
            return _this.formService;
        };
        this.getRegistrationService = function () {
            _this.onActive();
            return _this.registrationService;
        };
        this.getBulletinService = function () {
            _this.onActive();
            return _this.bulletinService;
        };
        this.getAuthService = function () {
            _this.onActive();
            return _this.authService;
        };
        this.getCourseService = function () {
            _this.onActive();
            return _this.courseService;
        };
        this.getExerciseService = function () {
            _this.onActive();
            return _this.exerciseService;
        };
        this.getUserService = function () {
            _this.onActive();
            return _this.userService;
        };
        this.getNotificationService = function () {
            _this.onActive();
            return _this.notificationService;
        };
        this.getFeedbackService = function () {
            _this.onActive();
            return _this.feedbackService;
        };
        this.getQuestionService = function () {
            _this.onActive();
            return _this.questionService;
        };
        this.getHistoryService = function () {
            _this.onActive();
            return _this.historyService;
        };
        this.getDashboardService = function () {
            _this.onActive();
            return _this.dashboardService;
        };
        this.getDocumentService = function () {
            _this.onActive();
            return _this.documentService;
        };
        this.getNoteService = function () {
            _this.onActive();
            return _this.noteService;
        };
        this.setDebugMode = function (debug) {
            (0, Utils_1.setGlobalDebugMode)(debug);
            _this.authService.setDebuggable(debug);
            _this.courseService.setDebuggable(debug);
            _this.exerciseService.setDebuggable(debug);
            _this.userService.setDebuggable(debug);
            _this.notificationService.setDebuggable(debug);
            _this.feedbackService.setDebuggable(debug);
            _this.questionService.setDebuggable(debug);
            _this.historyService.setDebuggable(debug);
            _this.dashboardService.setDebuggable(debug);
            _this.formService.setDebuggable(debug);
            _this.registrationService.setDebuggable(debug);
            _this.bulletinService.setDebuggable(debug);
            _this.documentService.setDebuggable(debug);
            _this.noteService.setDebuggable(debug);
        };
        this.isElectronApp = function () {
            return (0, Utils_1.isElectron)();
        };
        this.getDataNode = function (path) {
            var user = (0, UserCache_1.loadUser)();
            if (!user || user.role !== 'staff') {
                return Promise.reject('Permission denied!');
            }
            return (0, FirebaseUtils_1.getNode)(path);
        };
        this.setDataNode = function (path, data) {
            var user = (0, UserCache_1.loadUser)();
            if (!user || user.role !== 'staff') {
                return Promise.reject('Permission denied!');
            }
            return (0, FirebaseUtils_1.setNode)(path, data);
        };
        this.logger.log('constructor');
    }
    CodingbarApi.prototype.createServices = function (config) {
        this.authService = new AuthServiceImpl_1.AuthServiceImpl(config);
        this.courseService = new CourseServiceImpl_1.CourseServiceImpl(config);
        this.exerciseService = new ExerciseServiceImpl_1.ExerciseServiceImpl(config);
        this.userService = new UserServiceImpl_1.UserServiceImpl(config);
        this.notificationService = new NotificationServiceImpl_1.NotificationServiceImpl(config);
        this.feedbackService = new FeedbackServiceImpl_1.FeedbackServiceImpl(config);
        this.questionService = new QuestionServiceImpl_1.QuestionServiceImpl(config);
        this.historyService = new HistoryServiceImpl_1.HistoryServiceImpl(config);
        this.dashboardService = new DashboardServiceImpl_1.DashboardServiceImpl(config);
        this.formService = new FormServiceImpl_1.FormServiceImpl(config);
        this.registrationService = new RegistrationServiceImpl_1.RegistrationServiceImpl(config);
        this.bulletinService = new BulletinServiceImpl_1.BulletinServiceImpl(config);
        this.documentService = new DocumentServiceImpl_1.DocumentServiceImpl(config);
        this.noteService = new NoteServiceImpl_1.NoteServiceImpl(config);
    };
    CodingbarApi.GET = function () {
        if (CodingbarApi.instance) {
            return this.instance;
        }
        CodingbarApi.instance = new CodingbarApi();
        return CodingbarApi.instance;
    };
    CodingbarApi.prototype.setupSettings = function (env) {
        switch (env.toLowerCase()) {
            case 'fut':
                Settings_1.Settings.SERVER_CONFIG.connections = Settings_1.Settings.CONNECTIONS_FUT;
                break;
            case 'dev':
                Settings_1.Settings.SERVER_CONFIG.connections = Settings_1.Settings.CONNECTIONS_DEV;
                break;
            case 'azure_dev':
                Settings_1.Settings.SERVER_CONFIG.connections = Settings_1.Settings.CONNECTIONS_AZURE_DEV;
                break;
            case 'aws_fut':
                Settings_1.Settings.SERVER_CONFIG.connections = Settings_1.Settings.CONNECTIONS_AWS_FUT;
                break;
            case 'aws_staging':
                Settings_1.Settings.SERVER_CONFIG.connections = Settings_1.Settings.CONNECTIONS_AWS_STAGING;
                break;
            case 'aws_dev':
                Settings_1.Settings.SERVER_CONFIG.connections = Settings_1.Settings.CONNECTIONS_AWS_DEV;
                break;
            case 'local':
                Settings_1.Settings.SERVER_CONFIG.connections = Settings_1.Settings.CONNECTIONS_LOCAL;
                break;
        }
    };
    CodingbarApi.prototype.getProvider = function (env, provider) {
        switch (env.toLowerCase()) {
            case 'fut':
                return provider;
            case 'dev':
                return provider;
            case 'test':
                return provider;
            case 'devtest':
                return provider;
            case 'aws_fut':
                return provider;
            case 'azure_dev':
                return provider;
            case 'aws_dev':
                return provider;
            case 'local':
                return provider;
        }
        return 'airabbi';
    };
    CodingbarApi.prototype.init = function (env, provider) {
        var _this = this;
        var future = new Future_1.Future(Future_1.futureFunc);
        if (this.isInit) {
            this.logger.log('already init!');
            return future.promise;
        }
        this.isInit = true;
        this.env = env;
        this.config = {
            debuggable: false,
            logger: console,
            codingbar: this,
            provider: this.getProvider(env, provider),
            env: env
        };
        this.createServices(this.config);
        this.setupSettings(env);
        FirebaseApp_1.FirebaseApp.GET()
            .init(env)
            .then(function () {
            (0, Utils_1.setGlobalEnv)(env);
            Promise.all([
                _this.authService.init(env),
                _this.courseService.init(env),
                _this.exerciseService.init(env),
                _this.userService.init(env),
                _this.notificationService.init(env),
                _this.feedbackService.init(env),
                _this.questionService.init(env),
                _this.historyService.init(env),
                _this.dashboardService.init(env),
                _this.formService.init(env),
                _this.registrationService.init(env),
                _this.bulletinService.init(env),
                _this.documentService.init(env),
                _this.noteService.init(env),
                _this.getCoreService().init(env)
            ])
                .then(function () {
                if (env.toLowerCase() === 'fut' ||
                    env.toLowerCase() === 'aws_fut' ||
                    env.toLocaleLowerCase() === 'azure_dev') {
                    _this.setDebugMode(false);
                }
                else {
                    _this.setDebugMode(true);
                }
                future.resolve();
            })
                .catch(function (err) { return future.resolve(); });
        })
            .catch(function () {
            future.resolve();
        });
        return future.promise;
    };
    CodingbarApi.prototype.onActive = function () {
        if (this.userService) {
            this.userService
                .onActive()
                .then(function () {
            })
                .catch(function (err) {
            });
        }
    };
    CodingbarApi.prototype.getConfig = function () {
        return this.config;
    };
    CodingbarApi.prototype.sendBugReport = function (errorType, error, info) {
        var _this = this;
        var user = (0, UserCache_1.loadUser)();
        CoreServiceHelper_1.CoreServiceHelper.getHelper(this.config)
            .createData('bugs', {
            from: 'client',
            error: error,
            info: info,
            user: user,
            url: window.location.href
        })
            .then(function () {
            _this.logger.log('create bugreport successfully!');
        })
            .catch(function (err) {
            _this.logger.error(err);
        });
        CoreServiceHelper_1.CoreServiceHelper.getHelper(this.config)
            .sendEmail(['tengjie.huang@airabbi.com', 'edison.liang@airabbi.com'], "[Notice][".concat(errorType, "] Codingbar Bugreport"), "".concat(user ? JSON.stringify(user) : '', " <br/><br/> ").concat(window.location.href, " <br/><br/> ").concat(info ? JSON.stringify(info) : '', " <br/><br/> ").concat(errorType ? "type:".concat(errorType) : '', " "))
            .then(function () {
            _this.logger.log('send bugreport email successfully!');
        })
            .catch(function (err) {
            _this.logger.error(err);
        });
    };
    CodingbarApi.prototype.getEnv = function () {
        return this.env;
    };
    CodingbarApi.prototype.hasEmptyExercise = function (lesson) {
        if (lesson.exercises && lesson.exercises.find(function (e) { return e.id === undefined; })) {
            return true;
        }
        if (lesson.offlineExercises && lesson.offlineExercises.find(function (e) { return e.id === undefined; })) {
            return true;
        }
        return false;
    };
    CodingbarApi.prototype.stressTest = function (testMaxCount) {
        var _this = this;
        var promises = [];
        var uids = [];
        for (var i = 0; i < testMaxCount; i++) {
            uids.push("test-".concat(i));
        }
        uids.forEach(function (uid) {
            var code = "print(\"hello world!\")";
            promises.push(_this.getCourseService().submitCode('11111', '11111', '11111', uid, code, [], {}, 'exec', '2.0'));
        });
        var st = Date.now();
        Promise.all(promises)
            .then(function () {
            var et = Date.now();
            _this.logger.log('Done!!!!!!!!!!', et - st);
        })
            .catch(function (err) {
            _this.logger.error(err);
        });
    };
    CodingbarApi.prototype.getCoreService = function () {
        return CoreServiceHelper_1.CoreServiceHelper.getHelper(this.config);
    };
    CodingbarApi.prototype.dataApiTest = function () {
        var _this = this;
        this.logger.log('createData#');
        return this.getCoreService()
            .createData('tmp_test', { name: Date.now() })
            .then(function (result) {
            _this.logger.log('createData', result);
            _this.logger.log('queryData#');
            return _this.getCoreService()
                .queryData('tmp_test', {}, {}, {}, undefined)
                .then(function (data) {
                _this.logger.log('queryData', data);
            });
        });
    };
    CodingbarApi.prototype.info = function () {
        return "version 2.0.3 2021/05/27";
    };
    return CodingbarApi;
}());
exports.CodingbarApi = CodingbarApi;
window.codingbarApi = CodingbarApi.GET();
exports.codingbarApi = CodingbarApi.GET();
//# sourceMappingURL=index.js.map